import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import styled from 'styled-components';

import RadioGroup, { Radio } from '../../../../../../components/RadioGroup';
import ComparativeList from '../Comparative/ComparativeList';

import AlertMessage from '../../../../../../components/AlertMessage';
import EmptyState from '../../../../../../components/EmptyState';

import { getComparativeBy, changeComparativeType, comparativeTypes } from '../../../../../../redux/dashboard-completed';

import {
  getDashboardCompletedPeriodListUI,
  getDashboardCompletedComparativeBy,
  getDashboardCompletedComparativeByUI,
} from '../../../../../../redux/selectors';

import { Container, Col } from './styles';
import { Skeleton } from '@mui/material';
// maps

const ValuesInDisplayText = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 16px;
  color: var(--luft-primary);
  margin-bottom: 16px;
`;

export const chartValuesEnum = {
  PERFORMANCE: 'PERFORMANCE',
  WEIGHT: 'WEIGHT',
  VALUE: 'VALUE',
};

export const comparativeUnitsTraskey = {
  [chartValuesEnum.PERFORMANCE]: 'Performance',
  [chartValuesEnum.WEIGHT]: 'Peso',
  [chartValuesEnum.VALUE]: 'Valor',
};

class Clients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartValues: chartValuesEnum.PERFORMANCE,
    };
  }

  componentDidMount() {
    this.props.dispatch(changeComparativeType(comparativeTypes.CUSTOMER));
  }

  componentDidUpdate(prevProps) {
    const {
      data,
      currentRangeId,
      comparativeType,
      ui,
      periodListUI,
    } = this.props;

    if (
      moment(ui.requested).isBefore(periodListUI.received) ||
      (!data && (currentRangeId !== prevProps.currentRangeId || comparativeType !== prevProps.comparativeType))
    ) {
      this._getComparativeBy();
    }
  }

  _getComparativeBy = () => {
    this.props.dispatch(getComparativeBy());
  }

  _changeChartValues = (chartValues) => {
    this.setState({ chartValues });
  }

  _getComparativeListValues = () => {
    const { data } = this.props;

    switch (this.state.chartValues) {
      case chartValuesEnum.PERFORMANCE:
        return data.map(x => ({
          value: (x.onTimeQty / (x.onTimeQty + x.lateQty)) * 100,
          onTimeQty: x.onTimeQty,
          lateQty: x.lateQty,
          totalQty: x.onTimeQty + x.lateQty,
          text: x.label,
          shippingCompany: [
            {
              name: "TRANSPORTES LUFT LTDA",
              icon: "https://lens-storage.storage.googleapis.com/png/036dd7eb1149409bae36fc99848e2cc5",
              cnpj: "53.585.443/0001-58",
              onTimeQty: 101,
              lateQty: 50,
              onTimeWeight: 1181265.3400,
              lateWeight: 139566.6800,
              onTimeValue: 75743784.6700,
              lateValue: 7423839.7500,
              totalQty: 101 + 50,
              value: (101 / (101 + 50)) * 100,
            },
            {
              name: "TRANSPORTES LEGAIS LTDA",
              icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIEGcs4ajLntFjbcW5BxABI5zPDajx0V5ysA&s",
              cnpj: "53.585.443/0001-58",
              onTimeQty: 102,
              lateQty: 2,
              onTimeWeight: 1181265.3400,
              lateWeight: 139566.6800,
              onTimeValue: 75743784.6700,
              lateValue: 7423839.7500,
              totalQty: 102 + 2,
              value: (102 / (102 + 2)) * 100,
            }
          ]
        }));

      case chartValuesEnum.VALUE:
        return data.map(x => ({
          value: (x.onTimeValue + x.lateValue) / 1000000,
          text: x.label,
        }));

      default: // case chartValuesEnum.WEIGHT:
        return data.map(x => ({
          value: (x.onTimeWeight + x.lateWeight) / 1000,
          text: x.label,
        }));
    }
  }

  _renderList = () => {
    const { data, ui } = this.props;
    const { chartValues } = this.state;
    const customHeaders = [
      'Cliente',
      'Qtd. NF',
      'No prazo',
      'Atrasada',
      'Performance'
    ]

    if (ui.error) {
      return (
        <AlertMessage
          className="DashboardCompletedComparative__error"
          error
          message={ui.error}
          actionText="Tentar novamente"
          onRetry={this._getComparativeBy}
        />
      );
    }

    if (!data || !data[0]) {
      return (
        <EmptyState
          className="DashboardCompletedComparative__empty-state"
          message="Não existem dados para os parâmetros selecionados."
        />
      );
    }

    return (
      <ComparativeList
        title="Cliente"
        unit={chartValues}
        data={this._getComparativeListValues()}
        customHeaders={customHeaders}
        showDropdown={true}
      />
    );
  }

  render() {
    const { chartValues } = this.state;
    const { ui } = this.props;

    return (
      <div>
        <Container>
            <Col md9>
              {ui.isFetching ? (
                <Skeleton
                  variant="rectangular"
                  height="572px"
                  animation="wave"
                  style={{ borderRadius: 4}}
                />
              ) : (
                <>
                  <ValuesInDisplayText>{`${comparativeUnitsTraskey[chartValues]} por cliente`}</ValuesInDisplayText>
                  {this._renderList()}
                </>
              )}
            </Col>
            <Col md3>
              {ui.isFetching ? (
                <Skeleton
                  variant="rectangular"
                  height="572px"
                  animation="wave"
                  style={{ borderRadius: 4}}
                />
              ) : (
                <div className="DashboardCompletedConfig__container">
                  <div className="DashboardCompletedConfig__content">
                    <div className="DashboardCompletedConfig__section">
                      <div className="DashboardCompletedConfig__label">Valores do gráfico:</div>
                      <RadioGroup
                        compact
                        value={chartValues}
                        onChangeValue={this._changeChartValues}
                      >
                        <Radio value={chartValuesEnum.PERFORMANCE} label="Performance" />
                        <Radio value={chartValuesEnum.WEIGHT} label="Peso transportado" />
                        <Radio value={chartValuesEnum.VALUE} label="Valor transportado" />
                      </RadioGroup>
                    </div>
                  </div>
                </div>
              )}
            </Col>
        </Container>
      </div>
    );
  }
}

// redux

const mapStateToProps = state => ({
  data: getDashboardCompletedComparativeBy(state),
  ui: getDashboardCompletedComparativeByUI(state),
  periodListUI: getDashboardCompletedPeriodListUI(state),
  currentRangeId: state.dashboardCompleted.details.currentRangeId,
  comparativeType: state.dashboardCompleted.details.comparativeType,
});

export default connect(mapStateToProps)(Clients);
